export default __webpack_public_path__ + "static/314-5edd0e83198883ad8b04a405081f6ddf.gif";